<template>
  <div>
    <slot />
  </div>
</template>

<script lang="ts" setup>
import { buttonGroupProps } from './button-group'

defineOptions({
  name: 'VsButtonGroup',
})

const props = defineProps(buttonGroupProps)

// init here
</script>
